import script from "./PCSettingsBlockInventoryRegularization.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSettingsBlockInventoryRegularization.vue?vue&type=script&setup=true&lang=js"

import "./PCSettingsBlockInventoryRegularization.vue?vue&type=style&index=0&id=187cccf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187cccf0"]])

export default __exports__